/* CONTEGNO: one cart destination = the side drawer. */
(function () {
  'use strict';
  var pending = null;
  function offerUrl() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var dest = new URL(root + 'collections/shop-all-watches', window.location.origin);
    dest.searchParams.set('ct_open_cart', '1');
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) dest.searchParams.set('preview_theme_id', preview);
    return dest.pathname + dest.search;
  }
  function cartPath(url) {
    var cart = new URL(window.routes && window.routes.cart_url || '/cart', location.origin);
    return url.origin === location.origin && url.pathname.replace(/\/+$/, '') === cart.pathname.replace(/\/+$/, '');
  }
  window.contegnoOpenCartDrawer = function () {
    if (pending) return pending;
    pending = (async function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        window.location.assign(offerUrl());
        return;
      }
      try {
        var endpoint = new URL(location.href);
        endpoint.searchParams.delete('ct_open_cart');
        endpoint.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
        var response = await fetch(endpoint.pathname + endpoint.search, {
          credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart sections unavailable');
        var sections = await response.json();
        if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('Cart sections incomplete');
        var notification = document.querySelector('cart-notification');
        if (notification && notification.classList.contains('active') && typeof notification.close === 'function') notification.close();
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: null, sections: sections });
      } catch (error) {
        console.warn('CONTEGNO cart refresh:', error);
        // Never send customers to /cart if an AJAX refresh fails.
        drawer.open();
      }
    })().finally(function () { pending = null; });
    return pending;
  };
  // Capture existing cart links, including theme's header icon, notification,
  // quick-order lists, and links inserted after Ajax section refreshes.
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    var dest;
    try { dest = new URL(link.href, location.origin); } catch (err) { return; }
    if (!cartPath(dest)) return;
    event.preventDefault();
    event.stopPropagation();
    window.contegnoOpenCartDrawer();
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.code !== 'Space') return;
    var icon = event.target && event.target.closest ? event.target.closest('#cart-icon-bubble') : null;
    if (!icon) return;
    event.preventDefault();
    event.stopPropagation();
    window.contegnoOpenCartDrawer();
  }, true);
  if (new URLSearchParams(location.search).get('ct_open_cart') === '1') {
    var clean = new URL(location.href);
    clean.searchParams.delete('ct_open_cart');
    history.replaceState(history.state, '', clean.pathname + clean.search + clean.hash);
    window.contegnoOpenCartDrawer();
  }
})();

/* CONTEGNO - supplier-confirmed priority dispatch countdown.
   One-shot 09:59 window persists through cart drawer rerenders and reloads.
   Never resets when zero is reached. */
(function () {
  'use strict';
  if (window.__ctgPriorityDispatchPreviewTimer) return;
  window.__ctgPriorityDispatchPreviewTimer = true;

  var key = 'contegno_priority_dispatch_demo_deadline_v1';
  var durationMs = 599000; // 09:59
  var endAt = null;
  function deadline() {
    if (endAt !== null) return endAt;
    try {
      var saved = Number(window.localStorage.getItem(key));
      if (Number.isFinite(saved) && saved > 0) {
        endAt = saved;
      } else {
        endAt = Date.now() + durationMs;
        window.localStorage.setItem(key, String(endAt));
      }
    } catch (e) {
      // Storage can be blocked in embedded previews. At least do not
      // restart the clock when the cart is re-rendered in this page.
      endAt = Date.now() + durationMs;
    }
    return endAt;
  }

  function tick() {
    var boxes = document.querySelectorAll('[data-ctg-dispatch-preview]');
    if (!boxes.length) return;
    boxes.forEach(function (box) {
      var message = box.querySelector('[data-ctg-dispatch-message]');
      var timer = box.querySelector('[data-ctg-dispatch-timer]');
      if (!message) return;
      var remaining = Math.max(0, Math.ceil((deadline() - Date.now()) / 1000));
      if (remaining === 0) {
        message.textContent = 'Free tracked shipping';
        box.setAttribute('aria-label', 'Free tracked shipping.');
        return;
      }
      var minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      var seconds = String(remaining % 60).padStart(2, '0');
      var display = minutes + ':' + seconds;
      // Ajax rendering can replace this box between ticks, so resolve it fresh.
      if (timer) {
        timer.textContent = display;
      } else {
        message.textContent = 'Check out within ' + display + ' for priority dispatch';
      }
      box.setAttribute('aria-label', 'Check out within ' + display + ' for priority dispatch');
    });
  }

  tick();
  window.setInterval(tick, 1000);
})();